module.exports = __webpack_public_path__ + "img/KM-360A_13.ed4f63a6.jpg";